import { useState } from "react"
import Button from "@/components/core/Button/Button"
import Modal from "@/components/core/Modal/Modal"
import styles from "./confirmation-modal.module.scss"

const ConfirmationModal = ({
  showModal = false,
  setShowModal = () => {},
  onConfirm = () => {},
  onCancel = () => {},
  title = "",
  desc = "",
}) => {
  const [loading, setLoading] = useState(false)

  const handleConfirm = () => {
    setLoading(true)
    onConfirm().finally(() => {
      setLoading(false)
      setShowModal(false)
    })
  }

  const handleCancel = () => {
    onCancel()
    setShowModal(false)
  }

  return (
    <div className={styles.confirmationModal}>
      <Modal
        showModal={showModal}
        onModalClose={() => setShowModal(false)}
        hideCloseIcon={loading}
        isConfirm={true}
      >
        <div className="confirmation-modal">
          {title ? (
            <div className="confirmation-modal__title">{title}</div>
          ) : null}
          {desc ? <p className="confirmation-modal__desc">{desc}</p> : null}
          <div className="confirmation-modal__cta">
            <Button
              customClass="confirmation-modal__button"
              label="Yes"
              flexible
              type="black"
              onClick={handleConfirm}
              loading={loading}
              role="button"
              size="small"
            />
            <Button
              customClass="confirmation-modal__button"
              label="No"
              flexible
              type="ghost"
              onClick={handleCancel}
              disabled={loading}
              role="button"
              size="small"
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ConfirmationModal
